import {Debounce} from "./src/debounce.directive";

export * from './src/debounce.directive';

export default {
    directives: [Debounce]
}


// WEBPACK FOOTER //
// ./~/angular2-debounce/angular2-debounce.ts